module.exports = __webpack_public_path__ + "static/media/save.c2c0c6cf.svg";